module.exports = {"411603001":"柳湖街道","411603100":"城关回族镇","411603101":"新站镇","411603102":"鲁台镇","411603103":"四通镇","411603104":"临蔡镇","411603105":"安岭镇","411603106":"白楼镇","411603200":"朱集乡","411603201":"豆门乡","411603202":"冯塘乡","411603203":"刘振屯乡","411603204":"王店乡","411603205":"大连乡","411603206":"葛店乡","411603207":"黄集乡","411603209":"齐老乡","411603210":"郑集乡","411603211":"曹河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411603.json
// module id = 1798
// module chunks = 0